import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

const useStyles = makeStyles(() => ({
  closeButton: {
    border: '1px solid var(--color-main-orange)',
    padding: 0,
    color: 'var(--color-main-orange)',
    marginLeft: '20px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export default function CloseButton({ onClose }) {
  const iconStyles = useStyles();

  return (
    <div>
      <IconButton
        aria-label="close"
        size="small"
        className={iconStyles.closeButton}
        onClick={onClose}
      >
        <CloseOutlinedIcon fontSize="small" />
      </IconButton>
    </div>
  );
}
